import scrollLock from 'scroll-lock';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Menu {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);

		this.header = document.querySelector('[data-header]');
		this.header.style.opacity = 1;

		this.hamburger = document.querySelector('[data-hamburger]');
		this.menu = document.querySelector('[data-menu]');
		this.backBtns = document.querySelectorAll('.back-btn');
		this.subMenuBtns = document.querySelectorAll('.menu-item-has-children');
		this.subMenus = document.querySelectorAll('.sub-menu');
		this.isFrontpage = document.body.classList.contains('home');
		this.hero = document.querySelector('[data-hero]');
		this.menuHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--menu-height'));

		this.menuOpen = false;

		this.hamburger.addEventListener('click', (e) => {
			this.toggleMenu();
		});

		if (this.backBtns) {
			this.subMenuBtns.forEach((backbtn) => {
				backbtn.addEventListener('click', (e) => {
					this.closeSubMenus();
				});
			});
		}

		if (this.subMenuBtns) {
			this.subMenuBtns.forEach((menuParent) => {
				menuParent.addEventListener('click', (e) => {
					if (window.innerWidth < 992) {
						this.openSubMenu(e);
					}
				});
			});
		}

		ScrollTrigger.observe({
			target: window,
			type: 'scroll',
			tolerance: 20,
			onUp: (self) => {
				this.header.style.opacity = 1;
				this.header.classList.remove('is-hidden');
				let offset;
				let heroDimensions;
				if (this.hero) {
					heroDimensions = this.hero.getBoundingClientRect()
					offset = heroDimensions.height - this.menuHeight;
				}

				if (offset && window.pageYOffset <= offset) {
					this.header.classList.add('remove-white');
					this.header.style.opacity = 1;
				} else {
					this.header.classList.remove('remove-white');
					this.header.classList.add('c-header--white');
				}
			},
			onDown: (self) => {
				let heroDimensions;
				let percentage = null;
				if (this.hero) {
					heroDimensions = this.hero.getBoundingClientRect();
					percentage = window.scrollY / (heroDimensions.height - this.menuHeight);
				}

				if (this.header.style.opacity > 0) {
					if (this.isFrontpage && window.scrollY < heroDimensions.height) {
						this.header.style.opacity = 1 - percentage;
					} else {
						this.header.style.opacity = 1;
						this.header.classList.add('is-hidden');
					}
				} else {
					this.header.classList.add('is-hidden');
				}

				if (this.header.style.opacity == 0) {
					this.header.classList.add('is-hidden');
				}
			},
		});

		let FocusableElements = this.menu.querySelectorAll('li');

		const firstTarget = FocusableElements[0];
		const lastTarget = FocusableElements[FocusableElements.length - 1];

		const firstFocusableEl = firstTarget.firstElementChild;
		const lastFocusableEl = lastTarget.firstElementChild;

		window.addEventListener('keydown', (e) => {
			if (window.innerWidth < 992) {
				if (e.key === 'Escape') {
					this.closeMenu();
				}

				if (e.key === 'Tab' || e.key === 9) {
					if (e.shiftKey) {
						/* shift + tab */ if (document.activeElement === firstFocusableEl) {
							lastFocusableEl.focus();
							e.preventDefault();
						}
					} /* tab */ else {
						if (document.activeElement === lastFocusableEl) {
							firstFocusableEl.focus();
							e.preventDefault();
						}
					}
				}
			}
		});
	}

	toggleMenu() {
		this.menuOpen ? this.closeMenu() : this.openMenu();
	}

	openMenu() {
		this.menuOpen = true;

		scrollLock.disablePageScroll();

		document.body.classList.add('has-menu-open');

		this.menu.classList.add('is-active');

		this.hamburger.classList.add('is-active');
		this.hamburger.setAttribute('aria-expanded', true);
		this.hamburger.setAttribute('aria-label', 'button - close navigation menu');
	}

	closeMenu() {
		if (!this.menuOpen) {
			return new Promise((resolve) => {
				resolve();
			});
		}

		this.menuOpen = false;

		scrollLock.enablePageScroll();

		document.body.classList.remove('has-menu-open');

		this.menu.classList.remove('is-active');
		this.closeSubMenus();

		this.hamburger.classList.remove('is-active');
		this.hamburger.setAttribute('aria-expanded', false);
		this.hamburger.setAttribute('aria-label', 'button - open navigation menu');
	}

	openSubMenu(e) {
		e.target.nextElementSibling.classList.add('is-active');
	}

	closeSubMenus() {
		this.subMenus.forEach((submenu) => {
			submenu.classList.remove('is-active');
		});
	}
}
